document.addEventListener("DOMContentLoaded", function () {
  const shop_id_eu = document.getElementById("ShopifyshopID_EU")?.textContent
  const shop_id_current = document.getElementById("ShopifyshopID_current")?.textContent
  const shop_iso_code = document.getElementById("ShopifyCountry_IsoCode")?.textContent

  // Function to check and update sizes
  const checkExist = setInterval(() => {
    const swatchKing = document.querySelector("variant-swatch-king")

    if (swatchKing) {
      clearInterval(checkExist)

      setTimeout(() => {
        if (!hasApparelSize()) {
          createSizeTab()
          if (shop_iso_code === "gb") {
            setActiveSizeTab("UK")
            applySizeSystem("UK")
          } else if (shop_id_eu === shop_id_current) {
            setActiveSizeTab("EU")
            applySizeSystem("EU")
          } else {
            setActiveSizeTab("US")
            applySizeSystem("US")
          }
        }

        initSizeGuidePanel()
        swatchKing.classList.add("variantsShowed")
      }, 950)

      setTimeout(() => {
        swatchKing.classList.add("variantsShowed")
      }, 1000)
    }
  }, 1300)

  // Set up variant change listener
  const variantSelector = document.querySelector('[name="id"]')

  if (variantSelector) {
    variantSelector.addEventListener("change", updateVariantDetails)
  }

  const cartItems = document.querySelector(".cart__items")

  if (cartItems) {
    if (shop_id_eu === shop_id_current || shop_iso_code === "gb") {
      updateCartSizes(shop_iso_code)
    }
  }

  const productGrid = document.getElementById("product-grid")

  if (productGrid) {
    addColorsNumberPerProductCard()
  }
})

// Function to update sizes on variant change
function updateVariantDetails(event) {
  const selectedVariantId = event.target.value
  const variant = window.meta.product.variants.find(v => v.id === selectedVariantId)

  if (variant) {
    const skuElement = document.querySelector(".currentSKU span")
    if (skuElement && variant.sku) {
      skuElement.textContent = variant.sku
    }
  }
}

/* SIZE TABS UI (US / EU / UK / MONDO) */
function createSizeTab() {
  if (document.querySelector(".size-tab-container")) return

  const swatchSize = document.querySelector("#swatch-option2")
  if (!swatchSize) return

  const container = document.createElement("div")
  const wrapper = document.createElement("div")

  container.classList.add("size-tab-container")
  wrapper.classList.add("size-tab-wrapper")

  const sizeOptions = ["US", "EU", "UK", "Mondo"]

  sizeOptions.forEach((label, index) => {
    const btn = document.createElement("button")
    btn.type = "button"
    btn.classList.add("size-tab")
    btn.textContent = label
    btn.dataset.system = label === "Mondo" ? "Mondo" : label

    if (index === 0) btn.classList.add("active")
    wrapper.appendChild(btn)
  })

  container.appendChild(wrapper)
  swatchSize.parentNode.insertBefore(container, swatchSize)

  wrapper.addEventListener("click", function (event) {
    const btn = event.target.closest(".size-tab")
    if (!btn) return

    wrapper.querySelectorAll(".size-tab").forEach(b => b.classList.remove("active"))
    btn.classList.add("active")

    applySizeSystem(btn.dataset.system)
  })
}

function setActiveSizeTab(system) {
  const wrapper = document.querySelector(".size-tab-wrapper")
  if (!wrapper) return

  const btn = wrapper.querySelector(`.size-tab[data-system="${system}"]`)
  if (!btn) return

  wrapper.querySelectorAll(".size-tab").forEach(b => b.classList.remove("active"))
  btn.classList.add("active")
}

function applySizeSystem(system) {
  const sizeSpans = document.querySelectorAll(
    "li.swatch-view-item span[swatch-inside='true']"
  )

  sizeSpans.forEach(el => {
    if (!el.dataset.originalSize) {
      el.dataset.originalSize = el.textContent.trim()
    }
  })

  sizeSpans.forEach(el => {
    const originalUS = el.dataset.originalSize
    let nextValue = originalUS

    if (system === "EU") {
      nextValue = sizeConversionEU[originalUS] || originalUS
    } else if (system === "UK") {
      nextValue = sizeConversionUK[originalUS] || originalUS
    } else if (system === "Mondo") {
      nextValue = sizeConversionMondo[originalUS] || originalUS
    }

    el.textContent = nextValue
  })

  const addToCartButton = document.querySelector('form[action="/cart/add"] button[name="add"]')
  addToCartButton?.addEventListener("click", () => {
    if (system === "UK") observeCartNotification("gb")
    if (system === "EU") observeCartNotification("eu")
  })
}

function hasApparelSize() {
  const swatchListSize = document.querySelector("#swatch-option2 ul.swatch-view-button")
  if (!swatchListSize) return false

  const apparelSizes = new Set([
    "XXS", "XS", "S", "M", "L", "XL", "XXL", "XXXL",
    "ONE SIZE", "OS", "O/S"
  ])

  return Array.from(swatchListSize.querySelectorAll("span[swatch-inside='true']")).some(el => {
    const val = el.textContent.trim().toUpperCase()
    const num = parseFloat(val)
    return apparelSizes.has(val) || (!isNaN(num) && num >= 28)
  })
}

// Function to observe cart notifications for size updates
function observeCartNotification(shop_iso_code) {
  const cartNotification = document.getElementById("cart-notification")
  if (!cartNotification) return

  const observer = new MutationObserver(() => updateCartNotificationSizes(shop_iso_code))
  observer.observe(cartNotification, { childList: true, subtree: true })
}

// Update sizes in cart notifications
function updateCartNotificationSizes(shop_iso_code) {
  const conversionTable = shop_iso_code === "gb" ? sizeConversionUK : sizeConversionEU
  const cartNotificationProduct = document.getElementById("cart-notification-product")

  cartNotificationProduct?.querySelectorAll(".product-option").forEach(option => {
    const label = option.querySelector("dt")
    const valueElement = option.querySelector("dd")

    if (label?.textContent.trim() === "Size:" && valueElement) {
      const originalSize = valueElement.textContent.trim()
      const translatedSize = conversionTable[originalSize]
      if (translatedSize) {
        valueElement.textContent = translatedSize
      }
    }
  })
}

// Update sizes in the cart page
function updateCartSizes(shop_iso_code) {
  const conversionTable = shop_iso_code === "gb" ? sizeConversionUK : sizeConversionEU
  const cartItems = document.querySelectorAll(".cart-item__details dl div.product-option")

  cartItems.forEach(item => {
    const sizeLabel = item.querySelector("dt")
    const sizeValue = item.querySelector("dd")

    if (sizeLabel?.textContent.trim() === "Size:" && sizeValue) {
      const originalSize = sizeValue.textContent.trim()
      const translatedSize = conversionTable[originalSize]
      if (translatedSize) {
        sizeValue.textContent = translatedSize
      }
    }
  })
}

function addColorsNumberPerProductCard() {
  const productCards = document.querySelectorAll(".grid__item")

  productCards.forEach(card => {
    const checkSwatchExist = setInterval(() => {
      const swatchKingElement = card.querySelector("variant-swatch-king")

      // Check if the swatch block exists
      if (swatchKingElement) {
        clearInterval(checkSwatchExist)

        setTimeout(() => {
          const colorList = swatchKingElement.querySelector("ul")
          if (colorList) {
            const colorCount = colorList.querySelectorAll("li").length

            if (colorCount > 0) {
              // Create a new paragraph element to display the color count
              const colorParagraph = document.createElement("p")
              colorParagraph.classList.add("color-count")
              colorParagraph.textContent = `${colorCount} colors`

              // Find the .card__information__bottom .color-information element
              const colorInfoContainer = card.querySelector(
                ".card__information__bottom .color-information"
              )

              // Insert the color count paragraph inside .color-information
              if (colorInfoContainer) {
                colorInfoContainer.appendChild(colorParagraph)
              }
            }
          }
        }, 300)
      }
    }, 100) // Check every 100ms
  })
}

// Conversion tables
const sizeConversionEU = {
  2: "33.5",
  2.5: "34",
  3: "34.5",
  3.5: "35",
  4: "35.5",
  4.5: "36",
  5: "37",
  5.5: "37.5",
  6: "38",
  6.5: "38.5",
  7: "39",
  7.5: "40",
  8: "41",
  8.5: "41.5",
  9: "42",
  9.5: "42.5",
  10: "43",
  10.5: "44",
  11: "45",
  11.5: "45.5",
  12: "46",
  13: "47",
  14: "48",
  15: "49",
}

const sizeConversionUK = {
  2: "2.5",
  2.5: "2.5",
  3: "2.5",
  3.5: "2.5",
  4: "3",
  4.5: "3.5",
  5: "4",
  5.5: "4.5",
  6: "5",
  6.5: "5.5",
  7: "6",
  7.5: "6.5",
  8: "7",
  8.5: "7.5",
  9: "8",
  9.5: "8.5",
  10: "9",
  10.5: "9.5",
  11: "10",
  11.5: "10.5",
  12: "11",
  13: "12",
  14: "13",
  15: "14",
}

const sizeConversionMondo = {
  2: "20",
  2.5: "20.5",
  3: "21",
  3.5: "21.5",
  4: "22",
  4.5: "22.5",
  5: "23",
  5.5: "23.5",
  6: "24",
  6.5: "24.5",
  7: "25",
  7.5: "25.5",
  8: "26",
  8.5: "26.5",
  9: "27",
  9.5: "27.5",
  10: "28",
  10.5: "28.5",
  11: "29",
  11.5: "29.5",
  12: "30",
  13: "31",
  14: "32",
  15: "33",
}
